import React, {Component} from 'react';
import {Card, Tabs, Button, Input, message, List, Spin, Modal, Icon, Popover, Empty, Avatar} from "antd";
import {HEADER_HEIGHT, NAVIGATE_LEVEN2_MARGIN, NAVIGATE_LEVEN2_WIDTH} from "../../constants";
import "./weiboList.css";
import {getAllWeiboList} from "../../actions/weiboList";
import {formatDate,  uuid,showCommentEmotions} from "../../utils";
import {getCounts, getUserInfo} from "../../actions/weiBo";
import {getMediaList} from "../../actions/resourceList";
import {getMicroblogData, getGoProveData,getIfProveSuccessData} from "../../actions/authProve";
import InfiniteScroll from "react-infinite-scroller";
import EditWeiBo from "./editWeiBo";
import PopoverContent from "./popoverContent";
import {WeiboPicturesWall} from "./weiboPicturesWall";
import {Scrollbars} from "react-custom-scrollbars";
import {getAllEmotionsList} from "../../actions/weiboEmotionsList";
import * as actions from"../../actions/weiBo";
import * as utils from"../../utils";
import PrivateLetter from'./PrivateLetter'
import Headlines from'./Headlines'
import EmotionalAnalysis from "../../view/emotionalAnalysis/EmotionalAnalysis";
import { copySync } from 'fs-extra';

const { TabPane } = Tabs;
const { Search } = Input;
const { Meta } = Card;
const { confirm } = Modal;
class allWeiboList extends Component {
    queryStr = "";
    type = "all";

    weiboOpenId = 0;
    allStart = 2;
    auditStart = 2;
    releaseStart = 2;
    abandonStart = 2;
    timetaskStart=2;
    undoStart=2;

    allCount = 0;
    auditCount = 0;
    releaseCount = 0;
    abandonCount = 0;
    timetaskCount = 0;
    undoCount=0;

    default = {
        start : 1,
        size : 10
    };

    domain = "";

    numberOfOAuth = 0;

    constructor(props)
    {
        super(props);
        this.state = {
            isAuth : false,
            mediaCode: this.props.match.params.currentMedia,
            allDataSource: [],
            auditDataSource: [],
            releaseDataSource: [],
            abandonDataSource: [],
            timetaskDataSource: [],
            undoDataSource:[],

            allloading: false,
            allhasMore: true,
            auditloading: false,
            audithasMore: true,
            releaseloading: false,
            releasehasMore: true,
            abandonloading: false,
            abandonhasMore: true,
            timetaskloading: false,
            timetaskhasMore: true,
            undoloading: false,
            undohasMore: true,
            visible: false,
            confirmLoading: false,
            modalTitle : "发微博",
            visiblePopover: false,
            userInfo:{},//当前用户信息
            emotionsDataSource:[],//表情包数据
            emotionsDataMap:{},//表情包数据对应的图片链接
            touTiaoParms:{},
            isMediaVisible:false,
            authVisible:false,
            mediaId:[]
        };
        // let type=this.props.match.params.type;
        let type=this.props.type;
        this.type=type;//覆盖原始路由
        this.initDataSource(this.state.mediaCode,this.type,this.queryStr,this.default.start,this.default.size);
        this.initUserInfo(this.state.mediaCode);
        this.initEmotionsDataSource();
    }
    //解决切换路由微博时候输一局更新的问题
    componentWillReceiveProps(nextProps, nextContext) {
        console.log(nextProps, nextContext);
        let type= nextProps.type; //nextProps.match.params.type;
        this.type=type;//覆盖原始路由
        let mediaCode=nextProps.match.params.currentMedia;
        this.state.mediaCode=mediaCode;
        this.initDataSource(this.state.mediaCode,this.type,this.queryStr,this.default.start,this.default.size);
        this.initUserInfo(this.state.mediaCode);
        console.log(type,mediaCode)
    }
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        };
    }

    refresh(){
        this.refreshList();
    }

    initEmotionsDataSource() {
        getAllEmotionsList(this.state.mediaCode, this.state.type, (data) => {
            if (data && data.length && data.length > 0) {

                let map ={}

                data.map(d=>{d.emotion.map(item=>{map[item.value] = item.icon})});

                this.setState({
                    emotionsDataSource: data,
                    emotionsDataMap: map
                });
            }
        });
    }

    initUserInfo(code)
    {
        getUserInfo(this.state.mediaCode, (data)=>{
            if(data)
            {
                if(data.profile_url && data.profile_url !== "")
                {
                    this.state.userInfo=data;
                    this.domain = "https://www.weibo.com/"+data.profile_url;
                    this.setState({
                        isAuth : true,
                        isIdentification:true,
                    });
                }else{
                    this.state.userInfo={};
                    this.setState({});
                    // message.error("当前微博无法使用，请先认证");
                    this.getMicroblogDatas(this.state.mediaCode)
                }
            }else{
                this.state.userInfo={};
                this.setState({});
                // message.error("当前微博无法使用，请先认证");
                this.getMicroblogDatas(this.state.mediaCode)
            }
        });
    }
    
      authHandleCancel = e => {
        console.log(e);
        this.setState({
            isMediaVisible: false,
        });
      };
      authCancel = e => {
        console.log(e);
        this.setState({
            authVisible: false,
        });
      };
      authOk = e => {
        console.log(e);
        this.setState({
            authVisible: false,
            isIdentification:true,
            isMediaVisible:false
        });
      };
    // 是否认证
    getMicroblogDatas(code){
            getMicroblogData({mediaCode:code},(res)=>{
                console.log(res)
                if(res.data){
                    this.setState({
                        isIdentification:true,
                        isMediaVisible:false
                    })
                }else{
                    this.setState({
                        isMediaVisible:true
                    })
                }
            })
    }
    // 去认证
    getGoProveDatas() {
        let params={
            mediaCode: this.state.mediaCode
        }
        getGoProveData(params, (res) => {
            console.log(res)
            if (res) {
                res = JSON.parse(res.data);
                let keyCode = res.keycode;
                let openUrl = res.openurl;
                window.open(openUrl);
                this.getIfProveSuccessDatas(this.state.mediaCode,keyCode)
            } else {
                message.error('认证失败，请检查媒体信息!');
            }
        });
    }
    // 检查是否认证成功
    getIfProveSuccessDatas(code,keyCode) {
        let that = this;
        let params={
            mediaCode:code,
            keycode: keyCode
        }
        getIfProveSuccessData(params, (data) => {
            console.log(data)
            if (data.data) {
                this.setState({
                    authVisible:true,
                    isMediaVisible:false
                })
                this.initUserInfo()
            } else {
                this.setState({
                    isIdentification:false
                })
                if (that.numberOfOAuth < 20) {
                    /**反复验证*/
                    setTimeout(function () {
                        that.numberOfOAuth = that.numberOfOAuth + 1;
                        that.getIfProveSuccessDatas(code,keyCode)
                    }, 3000);
                }
            }
        })
    }

    initDataSource(mediaCode,type,queryStr,start,size)
    {
        getAllWeiboList(mediaCode,type,queryStr,start,size,(data)=>{
            if(type === "all")
            {
                this.allCount = data.count;
                this.setState({
                    allDataSource: data.data
                });
            }else if(type === "audit")
            {
                this.auditCount = data.count;
                this.setState({
                    auditDataSource: data.data
                });
            }else if(type === "release")
            {
                this.releaseCount = data.count;
                this.setState({
                    releaseDataSource: data.data
                });
            }else if(type === "abandon")
            {
                this.abandonCount = data.count;
                this.setState({
                    abandonDataSource: data.data
                });
            }
            else if(type === "timetask")
            {
                this.timetaskCount = data.count;
                this.setState({
                    timetaskDataSource: data.data
                });
            }
            else if(type === "undo")
            {
                this.undoCount = data.count;
                this.setState({
                    undoDataSource: data.data
                });
            }
            this.loadCountData(data.data);
        });
    }

    loadCountData(data)
    {
        let weiboIds = "";
        for(let i = 0; data && i < data.length; i++)
        {
            let wbid = data[i].weibo_id;
            if(wbid && wbid > 0)
            {
                if(i == 0)
                {
                    weiboIds += (wbid+"");
                }else {
                    weiboIds += (","+wbid);
                }
            }
        }
        //查询已发布微博的点赞数等信息
        if(weiboIds !== "")
        {
            getCounts(this.state.mediaCode, weiboIds, (data)=>{
                if(data)
                {
                    for(let i = 0; i < data.length; i++)
                    {
                        let weibo_mid = data[i].id;
                        let returnObj = {};
                        returnObj.attitudes = data[i].attitudes;
                        returnObj.comments = data[i].comments;
                        returnObj.reposts = data[i].reposts;
                        this.setWeiboCounts(weibo_mid, returnObj)
                    }
                }
            });
        }
    }

    fetchData = (dataType, start, callback) => {
        getAllWeiboList(this.state.mediaCode, dataType, this.queryStr, start, this.default.size,(data)=>{
            if(dataType === "all")
            {
                this.allStart++;
            }else if(dataType === "audit")
            {
                this.auditStart++;
            }else if(dataType === "release")
            {
                this.releaseStart++;
            }else if(dataType === "abandon")
            {
                this.abandonStart++;
            }
            else if(dataType === "timetask")
            {
                this.timetaskStart++;
            } else if(dataType === "undo")
            {
                this.undoStart++;
            }
            this.loadCountData(data.data);
            callback(data.data);
        });
    };

    handleInfiniteOnLoad = () => {
        let dataType = this.type;
        if(dataType === "all")
        {
            let data = this.state.allDataSource;
            this.setState({
                allloading: true,
            });

            if (data.length >= this.allCount) {
                if(data.length > 0)
                    message.warning("已到最底端");
                this.setState({
                    allhasMore: false,
                    allloading: false,
                });
                return;
            }
            this.fetchData(dataType, this.allStart,res => {
                data = data.concat(res);
                this.setState({
                    allDataSource:data,
                    allloading: false,
                });
            });
        }else if(dataType === "audit")
        {
            let data = this.state.auditDataSource;
            this.setState({
                auditloading: true,
            });
            if (data.length >= this.auditCount) {
                if(data.length > 0)
                    message.warning("已到最底端");
                this.setState({
                    audithasMore: false,
                    auditloading: false,
                });
                return;
            }
            this.fetchData(dataType, this.auditStart,res => {
                data = data.concat(res);
                this.setState({
                    auditDataSource:data,
                    auditloading: false,
                });
            });
        }else if(dataType === "release")
        {
            let data = this.state.releaseDataSource;
            this.setState({
                releaseloading: true,
            });
            if (data.length >= this.releaseCount) {
                if(data.length > 0)
                    message.warning("已到最底端");
                this.setState({
                    releasehasMore: false,
                    releaseloading: false,
                });
                return;
            }
            this.fetchData(dataType, this.releaseStart,res => {
                data = data.concat(res);
                this.setState({
                    releaseDataSource:data,
                    releaseloading: false,
                });
            });
        }else if(dataType === "abandon")
        {
            let data = this.state.abandonDataSource;
            this.setState({
                abandonloading: true,
            });
            if (data.length >= this.abandonCount) {
                if(data.length > 0)
                    message.warning("已到最底端");
                this.setState({
                    abandonhasMore: false,
                    abandonloading: false,
                });
                return;
            }
            this.fetchData(dataType, this.abandonStart,res => {
                data = data.concat(res);
                this.setState({
                    abandonDataSource:data,
                    abandonloading: false,
                });
            });
        }else if(dataType === "timetask")
        {
            let data = this.state.timetaskDataSource;
            this.setState({
                timetaskloading: true,
            });
            if (data.length >= this.timetaskCount) {
                if(data.length > 0)
                    message.warning("已到最底端");
                this.setState({
                    timetaskhasMore: false,
                    timetaskloading: false,
                });
                return;
            }
            this.fetchData(dataType, this.timetaskStart,res => {
                data = data.concat(res);
                this.setState({
                    timetaskDataSource:data,
                    timetaskloading: false,
                });
            });
        }else if(dataType === "undo")
        {
            let data = this.state.undoDataSource;
            this.setState({
                undoloading: true,
            });
            if (data.length >= this.undoCount) {
                if(data.length > 0)
                    message.warning("已到最底端");
                this.setState({
                    undohasMore: false,
                    undoloading: false,
                });
                return;
            }
            this.fetchData(dataType, this.undoStart,res => {
                data = data.concat(res);
                this.setState({
                    undoDataSource:data,
                    undoloading: false,
                });
            });
        }
    };

    showList()
    {
        let dataType = this.type;
        let content = "";
        if(dataType === "all")
        {
            content = this.getInfiniteScroll(this.state.allDataSource, this.state.allloading, this.state.allhasMore);
        }else if(dataType === "audit")
        {
            content = this.getInfiniteScroll(this.state.auditDataSource, this.state.auditloading, this.state.audithasMore);
        }else if(dataType === "release")
        {
            content = this.getInfiniteScroll(this.state.releaseDataSource, this.state.releaseloading, this.state.releasehasMore);
        }else if(dataType === "abandon")
        {
            content = this.getInfiniteScroll(this.state.abandonDataSource, this.state.abandonloading, this.state.abandonhasMore);
        }else if(dataType === "timetask")
        {
            content = this.getInfiniteScroll(this.state.timetaskDataSource, this.state.timetaskloading, this.state.timetaskhasMore);
        }else if(dataType === "undo")
        {
            content = this.getInfiniteScroll(this.state.undoDataSource, this.state.undoloading, this.state.undohasMore);
        }

        return content;
    }

    getInfiniteScroll(dataSource, loading, hasMore)
    {
        let content = <InfiniteScroll
            initialLoad={false}
            pageStart={0}
            loadMore={this.handleInfiniteOnLoad}
            hasMore={!loading && hasMore}
            useWindow={false}
        >
            <List
                dataSource={dataSource}
                renderItem={item => (
                    <List.Item key={item.id}>
                        <Weibo key={"weibo"+item.id} listClickCallback={()=>{
                            this.state.touTiaoParms={};
                            this.setState({})
                        }} {...item} refresh={()=>{this.refresh()}} emotionsDataSource={this.state.emotionsDataSource}  emotionsDataMap={this.state.emotionsDataMap} userInfo={this.state.userInfo} refreshList={this.refreshList.bind(this)} showWeibo={this.showWeibo.bind(this)} removeWeibo={this.removeWeibo.bind(this)} />
                    </List.Item>
                )}
            >
                {loading && hasMore && (
                    <div className="demo-loading-container">
                        <Spin />
                    </div>
                )}
            </List>
        </InfiniteScroll>;
        return content;
    }

    renderDatasource()
    {
        let currentTab = this.type;
        let weiboDatas;
        if(currentTab === 'myall')
        {
            weiboDatas = this.state.myallDataSource;
        }else if(currentTab === 'myaudit'){
            weiboDatas = this.state.myauditDataSource;
        }else if(currentTab === 'myrelease'){
            weiboDatas = this.state.myreleaseDataSource;
        }else if(currentTab === 'myabandon'){
            weiboDatas = this.state.myabandonDataSource;
        }else if(currentTab === 'timetask'){
            weiboDatas = this.state.timetaskDataSource;
        }else if(currentTab === 'undo'){
            weiboDatas = this.state.undoDataSource;
        }

        if(!weiboDatas)
        {
            return;
        }
        let weibos = [];

        for(let i = 0; i < weiboDatas.length; i++){
            let weibo = weiboDatas[i];
            weibo.uuid = weibo.uuid ? weibo.uuid: uuid();
            weibos.push(<Weibo listClickCallback={()=>{
                this.state.touTiaoParms={};
                this.setState({})
            }} key={weibo.uuid} refresh={()=>{this.refresh()}}  emotionsDataSource={this.state.emotionsDataSource} {...weibo} userInfo={this.state.userInfo} refreshList={this.refreshList.bind(this)} showWeibo={this.showWeibo.bind(this)} removeWeibo={this.removeWeibo.bind(this)}/>);
        }
        return weibos;
    }

    changeDataSource(key)
    {
        this.type = key;
        let load = false;
        if(key === 'all'){
            load = true;
            this.allStart = 2;
            this.setState({
                allloading: false,
                allhasMore: true
            })
        }else if(key === 'audit'){
            this.auditStart = 2;
            load = true;
            this.setState({
                auditloading: false,
                audithasMore: true
            })
        }else if(key === 'release'){
            this.releaseStart = 2;
            load = true;
            this.setState({
                releaseloading: false,
                releasehasMore: true
            })
        }else if(key === 'abandon'){
            this.abandonStart = 2;
            load = true;
            this.setState({
                abandonloading: false,
                abandonhasMore: true
            })
        }else if(key === 'timetask'){
            this.timetaskStart = 2;
            load = true;
            this.setState({
                timetaskloading: false,
                timetaskhasMore: true
            })
        }else if(key === 'undo'){
            this.undoStart = 2;
            load = true;
            this.setState({
                undoloading: false,
                undohasMore: true
            })
        }
        this.initData(key, this.default.start, !load);
    }

    initData = (currentTab, start, clear)=>{
        let win = window.top || window;
        let index = win.layer.load();
        this.initDataSource(this.state.mediaCode, currentTab, this.queryStr, start, this.default.size);
        win.layer.close(index);
    };

    openWeiboInfo()
    {
        if(this.domain !== "")
        {
            window.open(this.domain);
        }
    }

    handleOk = () => {
        this.setState({
            confirmLoading: true,
        });
        setTimeout(() => {
            this.setState({
                visible: false,
                confirmLoading: false,
            });
        }, 2000);
    };

    // 微博编辑页面是否正在loading
    childLoading = false;

    handleCancel = () => {
        if(!this.childLoading){
            this.setState({
                visible: false,
            });
        }
    };

    showModal = () => {
        this.setState({
            visible: true,
        });
    };

    setWeiboCounts(mid, countObj)
    {
        let dataType = this.type;
        if(dataType === "all")
        {
            this.setState(prevState =>{
                let allDataSource = prevState.allDataSource;
                for(let i = 0; i < allDataSource.length; i++)
                {
                    let weibo = allDataSource[i]
                    if(weibo.weibo_mid === mid)
                    {
                        if(countObj)
                        {
                            weibo.attitudes = countObj.attitudes;
                            weibo.comments = countObj.comments;
                            weibo.reposts = countObj.reposts;
                        }
                    }
                }
                return {allDataSource}
            });
        }else if(dataType === "audit")
        {
            this.setState(prevState =>{
                let auditDataSource = prevState.auditDataSource;
                for(let i = 0; i < auditDataSource.length; i++)
                {
                    let weibo = auditDataSource[i]
                    if(weibo.weibo_mid === mid)
                    {
                        if(countObj)
                        {
                            weibo.attitudes = countObj.attitudes;
                            weibo.comments = countObj.comments;
                            weibo.reposts = countObj.reposts;
                        }
                    }
                }
                return {auditDataSource}
            });
        }else if(dataType === "release")
        {
            this.setState(prevState =>{
                let releaseDataSource = prevState.releaseDataSource;
                for(let i = 0; i < releaseDataSource.length; i++)
                {
                    let weibo = releaseDataSource[i]
                    if(weibo.weibo_mid === mid)
                    {
                        if(countObj)
                        {
                            weibo.attitudes = countObj.attitudes;
                            weibo.comments = countObj.comments;
                            weibo.reposts = countObj.reposts;
                        }
                    }
                }
                return {releaseDataSource}
            });
        }else if(dataType === "abandon")
        {
            this.setState(prevState =>{
                let abandonDataSource = prevState.abandonDataSource;
                for(let i = 0; i < abandonDataSource.length; i++)
                {
                    let weibo = abandonDataSource[i]
                    if(weibo.weibo_mid === mid)
                    {
                        if(countObj)
                        {
                            weibo.attitudes = countObj.attitudes;
                            weibo.comments = countObj.comments;
                            weibo.reposts = countObj.reposts;
                        }
                    }
                }
                return {abandonDataSource}
            });
        }else if(dataType === "timetask")
        {
            this.setState(prevState =>{
                let timetaskDataSource = prevState.timetaskDataSource;
                for(let i = 0; i < timetaskDataSource.length; i++)
                {
                    let weibo = timetaskDataSource[i]
                    if(weibo.weibo_mid === mid)
                    {
                        if(countObj)
                        {
                            weibo.attitudes = countObj.attitudes;
                            weibo.comments = countObj.comments;
                            weibo.reposts = countObj.reposts;
                        }
                    }
                }
                return {timetaskDataSource}
            });
        }else if(dataType === "undo")
        {
            this.setState(prevState =>{
                let undoDataSource = prevState.undoDataSource;
                for(let i = 0; i < undoDataSource.length; i++)
                {
                    let weibo = undoDataSource[i]
                    if(weibo.weibo_mid === mid)
                    {
                        if(countObj)
                        {
                            weibo.attitudes = countObj.attitudes;
                            weibo.comments = countObj.comments;
                            weibo.reposts = countObj.reposts;
                        }
                    }
                }
                return {undoDataSource}
            });
        }
    }

    removeWeibo = (id)=>{
        //仅删除微博列表中的那条数据，删除API在弹窗中调用
        let dataType = this.type;
        if(dataType === "all")
        {
            this.setState(prevState =>{
                let allDataSource = prevState.allDataSource;
                allDataSource = allDataSource.filter(weibo=>weibo.id!==id);
                return {allDataSource}
            });
        }else if(dataType === "audit")
        {
            this.setState(prevState =>{
                let auditDataSource = prevState.auditDataSource;
                auditDataSource = auditDataSource.filter(weibo=>weibo.id!==id);
                return {auditDataSource}
            });
        }else if(dataType === "release")
        {
            this.setState(prevState =>{
                let releaseDataSource = prevState.releaseDataSource;
                releaseDataSource = releaseDataSource.filter(weibo=>weibo.id!==id);
                return {releaseDataSource}
            });
        }else if(dataType === "abandon")
        {
            this.setState(prevState =>{
                let abandonDataSource = prevState.abandonDataSource;
                abandonDataSource = abandonDataSource.filter(weibo=>weibo.id!==id);
                return {abandonDataSource}
            });
        }else if(dataType === "timetask")
        {
            this.setState(prevState =>{
                let timetaskDataSource = prevState.timetaskDataSource;
                timetaskDataSource = timetaskDataSource.filter(weibo=>weibo.id!==id);
                return {timetaskDataSource}
            });
        }else if(dataType === "undo")
        {
            this.setState(prevState =>{
                let undoDataSource = prevState.undoDataSource;
                undoDataSource = undoDataSource.filter(weibo=>weibo.id!==id);
                return {undoDataSource}
            });
        }
    };

    refreshList = () =>
    {
        this.setState({
            visible : false
        });
        this.changeDataSource(this.type);
    };

    showWeibo = (id) =>
    {
        this.weiboOpenId = id;

        this.setState({
            visible : true,
        })
    }

    render()
    {
        let border = 1;
        let cardMargin = 15;
       /* let h = parseInt(HEADER_HEIGHT) + cardMargin * 2 + 76 + border * 2;*/
        let h = window.innerHeight - 92 - parseInt(HEADER_HEIGHT)-30;
        let height = "calc(100vh - "+ h +"px)";
        let writeBtnAreaWidth = 300;
        let width = window.document.body.clientWidth - NAVIGATE_LEVEN2_WIDTH - NAVIGATE_LEVEN2_MARGIN - writeBtnAreaWidth;
        let bHeight=window.innerHeight - parseInt(HEADER_HEIGHT)-15;

        return (
            <div style={{padding: "15px" ,height:bHeight,overFlow:'hidden'}}>
                <Card  title={
                    <div style={{display:'flex',lineHeight:'30px',height:80}}>
                        <Meta
                            avatar={<Avatar style={{width:50,height:50}} src={this.state.userInfo.profile_image_url} />}
                            title={this.state.userInfo.screen_name}
                            description={
                                <div>
                                    <div title={this.state.userInfo.description} style={{width:100,overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'}}>
                                {this.state.userInfo.description}
                            </div>
                            <div style={{display:"flex",alignItems:"center"}}>{this.state.isIdentification?
                        <span style={{color:"#333",fontSize:"12px"}}>已认证</span>:<span style={{color:"#333",fontSize:"12px"}}>未认证</span>    
                        }
                        {this.state.isIdentification?null:<div style={{marginLeft:"10px"}}>
                            <Button onClick={()=>this.getGoProveDatas()} type="primary" size="small">去认证</Button></div>}
                        </div>
                        <Modal title="提示" visible={this.state.isMediaVisible} centered footer={                            
                            <div style={{display:"flex",justifyContent:"flex-end",}}>
                            <div onClick={this.authHandleCancel}>
                                <Button>取消</Button>
                            </div>
                            <div style={{marginLeft:"10px"}}>
                                <Button type="primary" onClick={()=>this.getGoProveDatas()}>认证</Button>
                            </div>
                        </div>
                        } onCancel={this.authHandleCancel}> 
                                            <div style={{color:"#333",fontSize:"18px",fontWeight:"bold",marginLeft:"40px"}}>
                                                此账号授权已过期，认证后方可正常使用!
                                            </div>
                                        </Modal>
                                        <Modal title="提示" visible={this.state.authVisible} centered footer={null} onCancel={this.authCancel}> 
                                            <div style={{color:"#333",fontSize:"18px",fontWeight:"bold"}}>
                                                认证成功!
                                            </div>
                                        </Modal>
                                </div>
                            }
                        />
                        
                        <div style={{display:'flex',marginLeft:50}}>
                            <div style={{}}>
                                <div style={{color:'#d9d9d9',textAlign:'center'}}>关注</div>
                                <div style={{fontSize:30,textAlign:'center'}}>{this.state.userInfo.friends_count?this.state.userInfo.friends_count:0 }</div>
                            </div>
                            <div style={{width:1,background:'#d9d9d9',marginLeft:20}}/>
                            <div style={{marginLeft:20}}>
                                <div style={{color:'#d9d9d9',textAlign:'center'}}>粉丝</div>
                                <div style={{fontSize:30,textAlign:'center'}}>{this.state.userInfo.followers_count?this.state.userInfo.followers_count:0}</div>
                            </div>
                            <div style={{width:1,background:'#d9d9d9',marginLeft:20}}/>
                            <div style={{marginLeft:20}}>
                                <div style={{color:'#d9d9d9',textAlign:'center'}}>微博</div>
                                <div style={{fontSize:30,textAlign:'center'}}>{this.state.userInfo.statuses_count?this.state.userInfo.statuses_count:0}</div>
                            </div>
                        </div>
                    </div>
                   
                    /*<Tabs defaultActiveKey="1" onChange={this.changeDataSource.bind(this)} >

                    <TabPane tab="全部" key="all"></TabPane>
                    <TabPane tab="审核中" key="audit"></TabPane>
                    <TabPane tab="已发布" key="release"></TabPane>
                    <TabPane tab="已弃用" key="abandon"></TabPane>
                    <TabPane tab="定时发布" key="timetask"></TabPane>
                    <TabPane tab="撤回" key="undo"></TabPane>
                </Tabs>*/
                } extra={
                    <div>
                        <Search placeholder="搜索" onSearch={value => this.searchWeiBo(value)} enterButton />
                    </div>
                } style={{ width: "100%"}} bodyStyle={{padding:"0px"}} headStyle={{border:"0px !important"}}>
                    <table border={0} cellPadding={0} cellSpacing={0} width={"100%"}>
                        <tbody>
                        <tr>
                            <td style={{width:width}}>
                                <div style={{width:width,minHeight:"404px"}}>
                                    <Scrollbars autoHeight autoHeightMax={document.body.clientHeight - HEADER_HEIGHT - 170 }>
                                        {this.showList()}
                                    </Scrollbars>
                                </div>
                            </td>
                            <td width={writeBtnAreaWidth} valign={"top"} style={{borderLeft:"1px solid #e8e8e8",paddingTop:"100px"}}>
                                <div style={{textAlign:"center"}}>
                                    <p><img src={"/cm-sites/images/mediaFusion/weibo_xie_icon.png"}/></p>
                                    <p style={{color:"#999999"}}>有什么新鲜事想告诉大家？</p>
                                    <p><Button type="primary" disabled={this.state.isAuth? null :"disabled"} onClick={()=>{
                                        this.state.touTiaoParms={};//清空参数
                                        this.setState({});
                                        this.showWeibo(0)
                                    }
                                    }>发微博</Button></p>
                                    <p><Button type="primary" disabled={this.state.isAuth?"":"disabled"} onClick={()=>{
                                        this.weiboOpenId=-1;
                                        this.state.touTiaoParms={};//清空参数
                                        this.setState({});
                                        this.Headlines.showModal({isAdd:true})
                                    }}>头条文章</Button></p>
                                    <p><Button type="primary" disabled={this.state.isAuth?"":"disabled"} style={{display:this.state.userInfo.message_switch?'inline-block':'none'}} onClick={()=>{
                                        this.PrivateLetter.showModal()
                                    }}>查看私信</Button></p>
                                    <p><Button style={{background: "#daedff",color:"#0050B3"}} disabled={this.state.isAuth?"":"disabled"} onClick={()=>this.openWeiboInfo()}>查看微博</Button></p>
                                    <Modal
                                        title={this.state.modalTitle}
                                        visible={this.state.visible}
                                        onCancel={this.handleCancel}
                                        onOk={this.handleOk}
                                        bodyStyle={{height:"680px"}}
                                        width={860}
                                        footer={null}
                                        keyboard={false}
                                        maskClosable={false}
                                    >
                                        <div className={'allWeiboListContent'} style={{height:'100%',}}>
                                            {/*<Scrollbars>*/}
                                                {/*<div style={{overflow:'hidden'}}>*/}

                                            {this.state.visible && <EditWeiBo key={uuid()} touTiaoParms={this.state.touTiaoParms}  touTiaoParmsCallback={(data)=>{
                                            //回调传入微博头条编辑器
                                            let parms={
                                                ...data,
                                            };
                                            this.state.visible=false;
                                            this.setState({});
                                            this.Headlines.showModal(parms)
                                        }} currentMedia={this.state.mediaCode} userInfo={this.state.userInfo}
                                                   removeWeibo={this.removeWeibo.bind(this)}
                                                   refreshList={this.refreshList.bind(this)}
                                                   fatherObj={this} weiboId={this.weiboOpenId} changeLoading={(status)=>{this.childLoading = status}}/>}
                                                {/*</div>*/}
                                            {/*</Scrollbars>*/}
                                        </div>
                                    </Modal>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </Card>
                <PrivateLetter mediaCode={this.state.mediaCode}  ref={(PrivateLetter)=>{this.PrivateLetter=PrivateLetter}}/>
                <Headlines ref={(Headlines)=>{this.Headlines=Headlines}} callback={(data)=>{
                    this.setState({
                        visible: true,
                        touTiaoParms:data
                    })
                }}/>
            </div>
        );
    }

    searchWeiBo = (value) =>{
        this.queryStr = value;
        this.initDataSource(this.state.mediaCode,this.type,value,this.default.start,this.default.size);
    };
}

export default allWeiboList;

class Weibo extends Component {
    constructor(props){
        super(props);

        this.state = {
            ...props,
            visible: false,
            sharedVisible:false,
            likedVisible:false,
            markedVisible:false,
            emotionsDataSource:this.props.emotionsDataSource,
            emotionsDataMap:this.props.emotionsDataMap,
            type:"face",
            myInput:'',
            pageNo:1,//评论
            pageSize:10,//评论
            markList:[],//评论列表
            markIsLast:false,
            pageNoLiked:1,//点赞
            pageSizeLiked:10,//点赞
            likedList:[],//点赞列表
           likedIsLast:false,
            pageNoShare:1,//分享
            pageSizeShare:10,//分享
            shareList:[],//分享列表
            shareIsLast:false,
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState(nextProps);
    }
    componentDidMount() {
        //this.initEmotionsDataSource()
    }

    showModal = () => {
        this.setState({
            visible: true,
        });
    };

    handleCancel = () => {
        this.setState({
            visible: false,
        });
    };

    showModalPopover = () => {
        this.setState({
            visiblePopover: true,
        });
    };

    handleCancelPopover = () => {
        this.setState({
            visiblePopover: false,
        });
    };

    render() {
        let fileList = [];
        let images = this.state.picUrls;
        {images.map((item, i)=>
        {
            let file = {};
            file.name = "";
            file.status = "done";
            file.uid = i;
            file.url = item;
            fileList.push(file);
        })}
        return (
            <div style={{padding:"25px", borderBottom :"1px solid #e8e8e8",width:"100%"}}>
                <div>
                    <span style={{fontSize:"12pt",color:"#175199",fontWeight:900,cursor:"pointer"}}>{`${this.state.submitterName}(${this.state.submitter})`}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                    <span style={{fontSize:"9pt",color:"#999999"}}>创作于{formatDate(this.state.createDate.time)}</span>
                    {
                        this.state.statusName!==""?<span style={{float:"right",height:"30px", background: "#f0f2f5", color:"#333333", paddingRight:"10px", paddingLeft:"10px", textAlign: "center", verticalAlign:"middle"}}>
                        <span style={{verticalAlign: "middle", display: "inline-block"}}>{this.state.statusName}</span>
                            {
                                this.state.statusName.indexOf("发布") > -1 ?<span>
                                &nbsp;&nbsp;
                                    <span style={{borderLeft: "solid 1px #dee1e6", height: "18px", verticalAlign: "middle", display: "inline-block"}}></span>
                                    &nbsp;&nbsp;
                                    <span style={{display: "inline-block", paddingTop:"1px"}}><img src={"/cm-sites/images/mediaFusion/weibo_popover.png"}/></span>
                                    &nbsp;
                                    <span style={{verticalAlign: "middle", display: "inline-block", cursor:"pointer"}} onClick={this.showModalPopover}>发布进度</span>
                            <Modal
                                   title={"发布进度"}
                                   visible={this.state.visiblePopover}
                                   onCancel={this.handleCancelPopover}
                                   footer={null}
                                   keyboard={false}
                            >
                                <PopoverContent currentMedia={this.state.mediaCode} weiboId={this.state.id}/>
                            </Modal>
                        </span>:""
                            }
                    </span>:""
                    }
                    <span style={{float:"right",fontSize:"9pt",color:"#999999",paddingRight: "40px"}}>{this.state.updateDate?formatDate(this.state.updateDate.time):""}</span>
                </div>
                <div style={{paddingTop: "10px"}} onClick={() => {
                    this.props.listClickCallback&& this.props.listClickCallback();
                    this.props.showWeibo(this.state.id);
                }}>
                    <span style={{cursor:"pointer",whiteSpace:"normal",wordBreak:"break-all",wordWrap:"break-word"}}  >{showCommentEmotions(this.state.content,this.state.emotionsDataMap)}</span>
                </div>
                {this.state.touTiaoArticle ? <div style={{position: 'relative',paddingTop: "10px"}} onClick={() => {
                        this.props.listClickCallback&& this.props.listClickCallback();
                        this.props.showWeibo(this.state.id);
                    }}>
                        <img src={this.state.touTiaoArticle.cover}
                             style={{width: 600, height: 257, objectFit: 'cover', cursor: 'pointer'}} alt=""
                            />
                        <div style={{
                            fontSize: 14,
                            color: 'white',
                            position: 'absolute',
                            top: 225,
                            left: 20
                        }}>{this.props.userInfo.screen_name}</div>
                        <div style={{width: 600, background: '#f2f2f5', padding: '12px 16px 7px'}}>
                            <div style={{
                                fontSize: 22,
                                color: '#333333',
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                                wordWrap: 'break-word',
                                overflow: 'hidden'
                            }}>{this.state.touTiaoArticle.title}</div>
                            <div style={{fontSize: 14, color: '#808080'}}>{this.state.touTiaoArticle.summary}</div>
                        </div>
                        <div>

                        </div>
                    </div> :
                    <div style={{paddingTop: "10px"}}>
                        <WeiboPicturesWall fileList={fileList} isShowRemoveBtn={false} listShow={true}/>
                    </div>
                }
                {
                    this.props.statusName === '发布' ? <div style={{paddingTop: "20px"}}>
                    <span style={{fontSize: "9pt", color: "#7292ba", fontWeight: 700,cursor:'pointer'}}
                    onClick={()=>{
                        this.state.pageNoShare=1;
                        this.getShare() }}
                    >
                        <img style={{paddingBottom: "3px"}} src={"/cm-sites/images/mediaFusion/weibo_fx.png"}/>
                        分享{this.state.reposts ? this.state.reposts : "0"}次
                    </span>&nbsp;&nbsp;&nbsp;&nbsp;
                            <span onClick={() => {
                                this.state.pageNoLiked=1;
                                this.getLiked()
                            }} style={{fontSize: "9pt", color: "#7292ba", fontWeight: 700,cursor:'pointer'}}>
                        <img style={{paddingBottom: "4px"}} src={"/cm-sites/images/mediaFusion/weibo_dz.png"}/>
                        点赞{this.state.attitudes ? this.state.attitudes : "0"}
                    </span>&nbsp;&nbsp;&nbsp;&nbsp;
                            <span onClick={() => {
                                this.state.pageNo=1;
                                this.getMarked();
                            }} style={{fontSize: "9pt", color: "#7292ba", fontWeight: 700,cursor:'pointer'}}>
                        <img style={{paddingBottom: "3px"}} src={"/cm-sites/images/mediaFusion/weibo_pl.png"}/>
                                {this.state.comments ? this.state.comments : "0"}条评论
                    </span>
                    {/*        &nbsp;&nbsp;&nbsp;&nbsp;*/}
                    {/*<span style={{fontSize:"9pt",color:"#7292ba",fontWeight:700,cursor:'pointer'}} onClick={()=>{*/}
                    {/*    this.getextractSentimentByTweetIdexport();*/}
                    {/*}}>*/}
                    {/*    <Icon type="fund" />*/}
                    {/*    情感分析*/}
                    {/*</span>*/}
                    {/*        <EmotionalAnalysis ref={(EmotionalAnalysis)=>this.EmotionalAnalysis=EmotionalAnalysis}/>*/}
                        </div>
                        : null
                }
                {this.renderShared()}
                {this.renderLiked()}
                {this.renderMarked()}
            </div>
        );
    }

    getextractSentimentByTweetIdexport(){
        // console.log(this.props);
        if (this.props.analysisResultJson) {
            let data = JSON.parse(this.props.analysisResultJson);
            if(data.comment_time_line){
                data.publishUrl=this.props.publishUrl;//微博的发布链接
                this.EmotionalAnalysis.showModal(data)
            }else {
                message.info('暂无分析数据')
            }
        }
    }
    //获取分享
    getShare() {
        let body = {
            mediaCode: this.state.mediaCode,
            weiboId: this.props.weibo_mid,
            pageNo: this.state.pageNoShare,
            pageSize: this.state.pageSizeShare
        };
        if (this.state.pageNoShare === 1) {
            this.state.shareList = [];
        }
        actions.getRepostListById(body, (data) => {
            if (data && data.reposts) {
                if (data.reposts && data.reposts.length < this.state.pageSizeShare && data.reposts.length === 0) {
                    this.state.shareIsLast = true;
                } else {
                    this.state.shareIsLast = false
                }
                if (this.state.pageNoShare === 1) {
                    this.setState({
                        shareList: data.reposts,
                        sharedVisible: true
                    });
                } else {
                    this.setState({
                        shareList: this.state.shareList.concat(data.reposts),
                        sharedVisible: true
                    });
                }
            } else {
                this.state.shareIsLast = true;
                this.setState({
                    shareList: [],
                    sharedVisible: true
                });
            }

        })
        // this.setState({sharedVisible: true})
    }

    //获取点赞
    getLiked() {
        let body = {
            mediaCode: this.state.mediaCode,
            weiboId: this.props.weibo_mid,
            pageNo: this.state.pageNoLiked,
            pageSize: this.state.pageSizeLiked
        };
        if (this.state.pageNoLiked === 1) {
            this.state.likedList = [];
        }
        actions.getLikeListById(body, (data) => {
            if (data && data.attitudes) {
                if (data.attitudes && data.attitudes.length < this.state.pageSizeLiked) {
                    this.state.likedIsLast = true
                } else {
                    this.state.likedIsLast = false
                }
                if (this.state.pageNoLiked === 1) {
                    this.setState({
                        likedList: data.attitudes,
                        likedVisible: true
                    });
                } else {
                    this.setState({
                        likedList: this.state.likedList.concat(data.attitudes),
                        likedVisible: true
                    });
                }
            } else {
                this.state.likedIsLast = true
                this.setState({
                    likedList: [],
                    likedVisible: true
                });
            }

        })
    }

    //获取评论数据
    getMarked() {
        console.log(this.props);
        let body = {
            mediaCode: this.state.mediaCode,//this.state.mediaCode,
            weiboId: this.props.weibo_mid,
            pageNo: this.state.pageNo,
            pageSize: this.state.pageSize
        };
        actions.getCommentsByWeiboId(body, (data) => {
            let comments = [];
            if (this.state.pageNo === 1) {
                if (data && data.comments) {
                    comments = data.comments;
                    if (data.comments.length < this.state.pageSize) {
                        this.state.markIsLast = true;
                    }
                }else{
                    this.state.markIsLast = true;
                }
                this.setState({markedVisible: true})
            } else {
                if (data && data.comments) {
                    if (data.comments.length > 0) {
                        comments = this.state.markList.concat(data.comments);
                        if (data.comments.length < this.state.pageSize) {
                            this.state.markIsLast = true;
                        }
                    } else {
                        this.state.markIsLast = true;
                    }

                }else{
                    this.state.markIsLast = true;
                }
                this.setState({})
            }

            // this.state.markList
            // this.state.markList.forEach((item,i)=>{
            //     item.markStatus=false;
            //     item.mark='';
            // });
            let _comments = {}; // 所有的评论
            let _reply = {};    // 所有的回复
            comments.map((item,i)=>{
                item.markStatus=false;
                item.mark='';
                // 评论
                if(item.id === item.rootid){
                    _comments[item.id] = item;
                }else {
                    // 回复
                    if(!_reply[item.rootid]){
                        _reply[item.rootid] = [];
                    }
                    _reply[item.rootid].push(item);
                }
            });

            for(var key in _reply){
                if(_comments[key]){
                    _comments[key].child = _reply[key];
                }
            }

            let comments_reply_list = Object.values(_comments);
            this.setState({
                markList: comments_reply_list
            })
        });

    }

    renderShared() {
        return (
            <Modal title="分享"
                   visible={this.state.sharedVisible}
                   onOk={() => {
                   }}
                   onCancel={() => {
                       this.setState({sharedVisible: false})
                   }}
                   footer={null}
                   width={400}
            >
                <div style={{height: '60vh'}}>
                    <Scrollbars>
                        {this.state.shareList.length?this.state.shareList.map((item, i) => {
                            let user = item.user;
                            return (
                                <div key={i}>
                                    <div style={{display: 'flex', paddingBottom: 20,paddingTop: 20}}>
                                        <div onClick={()=>{this.openBlankWeiBo(user.idstr)}}><img style={{width: 35, height: 35, objectFit: 'cover',cursor:'pointer'}}
                                                  src={user.profile_image_url}
                                                  alt=""/></div>
                                        <div style={{
                                            marginLeft: 20
                                        }}>
                                            <div style={{color: '#FF6600',cursor:'pointer'}} onClick={()=>{this.openBlankWeiBo(user.idstr)}}>{user.screen_name}</div>
                                            <div>{item.created_at ? utils.timeago(item.created_at) : null}</div>
                                            <div title={item.text} style={{width:285,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{ showCommentEmotions(item.text,this.state.emotionsDataMap)}</div>
                                        </div>
                                    </div>
                                    <div style={{height: 1, background: '#f2f2f2'}}></div>
                                </div>
                            )
                        }):<Empty/>    }
                        {
                            this.state.shareList.length ? (
                                    this.state.shareIsLast ? <div style={{
                                        background: '#fff2e6',
                                        fontSize: 12,
                                        color: '#808080',
                                        padding: 5,
                                        textAlign: 'center',
                                    }}>
                                        由于部分用户进行定向转发，你无法查看剩余转发内容。
                                    </div> : null)
                                : null
                        }

                        {
                            this.state.shareIsLast?null:<div onClick={()=>this.shareMore()} style={{height: 30, lineHeight: '30px', textAlign: "center", cursor: 'pointer'}}>加载更多<Icon
                                type="down"/></div>
                        }
                    </Scrollbars>
                </div>
            </Modal>
        )
    }

    renderLiked() {

        return (
            <Modal title="点赞"
                   visible={this.state.likedVisible}
                   onOk={() => {
                   }}
                   onCancel={() => {
                       this.setState({likedVisible: false})
                   }}
                   footer={null}
                   width={400}
            >
                <div style={{height: '60vh'}}>
                    <Scrollbars>
                        {this.state.likedList.length?this.state.likedList.map((item, i) => {
                            let user = item.user;
                            return (
                                <div key={i}>
                                    <div style={{display: 'flex', paddingBottom: 20,paddingTop: 20}}>
                                        <div  onClick={()=>{this.openBlankWeiBo(user.idstr)}}><img style={{width: 35, height: 35, objectFit: 'cover',cursor:'pointer'}}
                                                  src={user.profile_image_url}
                                                  alt=""/></div>
                                        <div style={{
                                            height: 32,
                                            lineHeight: '35px',
                                            marginLeft: 20,
                                            color: '#FF6600',cursor:'pointer'
                                        }}  onClick={()=>{this.openBlankWeiBo(user.idstr)}}>{user.screen_name}</div>
                                    </div>
                                    <div style={{height: 1, background: '#f2f2f2'}}></div>
                                </div>
                            )
                        }):<Empty/> }
                        {this.state.likedIsLast?null:<div style={{height: 30, lineHeight: '30px', textAlign: "center", cursor: 'pointer'}}
                            onClick={()=>{
                                this.likedMore()
                            }}
                        >加载更多<Icon
                            type="down"/></div>}

                    </Scrollbars>
                </div>

            </Modal>
        )
    }

    renderMarked() {
        let height = "calc(60vh - "  +"100px)";
        return (
            <Modal title="评论"
                   visible={this.state.markedVisible}
                   footer={null}
                   onOk={() => {
                   }}
                   onCancel={() => {
                       this.setState({markedVisible: false})
                   }}>
                <div style={{height: '60vh'}}>
                    <div style={{paddingRight: 10}}>
                        <div style={{display: 'flex', paddingBottom: 20}}>
                            <div style={{cursor:'pointer'}}  onClick={()=>{this.openBlankWeiBo(this.props.userInfo.idstr)}} ><img style={{width: 35, height: 35, objectFit: 'cover'}}
                                      src={this.props.userInfo.profile_image_url}
                                      alt=""/></div>
                            <div style={{width: '88%', marginLeft: 20,}}><Input placeholder="请输入评论内容"
                                                                                maxLength={140}
                                                                                value={this.state.myInput}
                                                                                onChange={(e) => {
                                                                                    this.setState({
                                                                                        myInput: e.target.value
                                                                                    })
                                                                                }}/>
                                <div style={{lineHeight: '32px', paddingTop: 10}}>
                                    <Popover placement="bottomLeft" content={this.renderEmotionsDataSource({})}
                                             trigger="click" style={{width: "20px;"}} arrowPointAtCenter>
                                        <img style={{cursor: "pointer", paddingRight: "10px"}}
                                             src={"/cm-sites/images/mediaFusion/emotion.png"}/>
                                    </Popover>
                                    <Button type="primary" style={{float: "right"}} onClick={() => {
                                        this.createWeiboComment()
                                    }}>评论</Button>
                                </div>
                            </div>
                        </div>


                    </div>
                    <div style={{height: height}}>
                        <Scrollbars>
                            <div style={{paddingRight: 10}}>
                                {
                                    this.state.markList.length?   this.state.markList.map((item, i) => {
                                        let user=item.user;
                                        return (
                                            <div style={{display: 'flex', paddingBottom: 20}}>
                                                <div onClick={()=>{this.openBlankWeiBo(user.idstr)}}><img style={{width: 35, height: 35, objectFit: 'cover',cursor:'pointer'}}
                                                          src={item.user.profile_image_url}
                                                          alt=""/></div>
                                                <div style={{width: '88%', marginLeft: 20,}}>
                                                    <div onClick={()=>{this.openBlankWeiBo(user.idstr)}} style={{cursor:'pointer'}}>
                                                        <span style={{color: '#FF6600'}}>{item.user && item.user.screen_name ? item.user.screen_name + ':' : null}</span>
                                                        { showCommentEmotions(item.text,this.state.emotionsDataMap)}
                                                    </div>
                                                    <div style={{}}>
                                                        <div style={{
                                                            float: 'left',
                                                            fontSize: 12
                                                        }}>{item.created_at ? utils.timeago(item.created_at) : null}</div>
                                                        <div style={{float: 'right', cursor: 'pointer'}} onClick={()=>{
                                                            item.markStatus=!item.markStatus;
                                                            this.setState({})
                                                        }}>回复</div>
                                                        {item && item.user && item.user.idstr === this.props.userInfo.idstr ?
                                                            <div
                                                                style={{
                                                                    float: 'right',
                                                                    marginRight: 20,
                                                                    cursor: 'pointer'
                                                                }} onClick={() => {
                                                                this.deleteMark(item)
                                                            }}>删除
                                                            </div> : null}

                                                        <div style={{clear: 'both'}}/>
                                                    </div>

                                                    {item.markStatus? <div style={{width: '100%', marginTop: 20}}><Input
                                                        placeholder="请输入评论内容"
                                                        maxLength={140}
                                                        value={item.mark}  onChange={(e) => {
                                                        item.mark= e.target.value;
                                                        this.setState({})
                                                    }}/>
                                                        <div style={{lineHeight: '32px', paddingTop: 10}}>
                                                            <Popover placement="bottomLeft"
                                                                     content={this.renderEmotionsDataSource(item)}
                                                                     trigger="click" style={{width: "20px;"}}
                                                                     arrowPointAtCenter>
                                                                <img style={{cursor: "pointer", paddingRight: "10px"}}
                                                                     src={"/cm-sites/images/mediaFusion/emotion.png"}/>
                                                            </Popover>
                                                            <Button type="primary" style={{float: "right"}} onClick={()=>{
                                                                this.replyComment(item)
                                                            }} >评论</Button>
                                                        </div>
                                                    </div>:null}

                                                    {/*//评论的子评论*/}
                                                    {
                                                        item.child ? item.child.map((reply, i)=>{
                                                            return (
                                                                <div>
                                                                    <div style={{display: 'flex', paddingBottom: 20}}>
                                                                        <div><img style={{width: 35, height: 35, objectFit: 'cover'}}
                                                                                  src={reply.user.profile_image_url}
                                                                                  alt=""/></div>
                                                                        <div style={{width: '88%', marginLeft: 20,}}>
                                                                            <div>
                                                                <span
                                                                    style={{color: '#FF6600'}}>{reply.user && reply.user.screen_name ? reply.user.screen_name + ':' : null}</span><span>{ showCommentEmotions(reply.text,this.state.emotionsDataMap)}</span>
                                                                            </div>
                                                                            <div style={{}}>
                                                                                <div style={{float: 'left',fontSize:12}}>2分钟前</div>
                                                                                <div style={{float: 'right', cursor: 'pointer'}} onClick={()=>{
                                                                                    reply.markStatus=!reply.markStatus;
                                                                                    this.setState({})
                                                                                }}>回复</div>
                                                                                {reply && reply.user && reply.user.idstr === this.props.userInfo.idstr ?
                                                                                    <div
                                                                                        style={{
                                                                                            float: 'right',
                                                                                            marginRight: 20,
                                                                                            cursor: 'pointer'
                                                                                        }} onClick={() => {
                                                                                        this.deleteMark(reply)
                                                                                    }}>删除
                                                                                    </div> : null}
                                                                                <div style={{clear: 'both'}}/>
                                                                            </div>


                                                                        </div>
                                                                    </div>

                                                                    {reply.markStatus? <div style={{width: '100%', marginTop: 20}}>
                                                                        <Input
                                                                        placeholder="请输入评论内容"
                                                                        maxLength={140}
                                                                        value={reply.mark}  onChange={(e) => {
                                                                        reply.mark= e.target.value;
                                                                        this.setState({})
                                                                    }}/>
                                                                        <div style={{lineHeight: '32px', paddingTop: 10}}>
                                                                            <Popover placement="bottomLeft"
                                                                                     content={this.renderEmotionsDataSource(reply)}
                                                                                     trigger="click" style={{width: "20px;"}}
                                                                                     arrowPointAtCenter>
                                                                                <img style={{cursor: "pointer", paddingRight: "10px"}}
                                                                                     src={"/cm-sites/images/mediaFusion/emotion.png"}/>
                                                                            </Popover>
                                                                            <Button type="primary" style={{float: "right"}} onClick={()=>{
                                                                                this.replyComment(reply)
                                                                            }} >评论</Button>
                                                                        </div>
                                                                    </div>:null}
                                                                </div>
                                                            )
                                                        }) : null
                                                    }
                                                </div>
                                            </div>
                                        )
                                    })
                                    :<Empty/>
                                }
                            </div>
                            {
                                this.state.markIsLast ? null : <div style={{
                                    height: 30,
                                    lineHeight: '30px',
                                    textAlign: "center",
                                    cursor: 'pointer'
                                }} onClick={() => {
                                    this.markMore()
                                }}>加载更多<Icon
                                    type="down"/>
                                </div>
                            }

                        </Scrollbars>
                    </div>
                </div>

            </Modal>
        )
    }

  showComment(text,map){
        var reg = /(\[[^\]]+\])/;

        var matchResult = text.match(reg);
        if(!matchResult){
            //未匹配出表情
            return <span>{text}</span>
        }else {
            //替换表情
            var tag;
            var key = matchResult[0];
            var url = map[key];
            if(url){
                //查询到表情
                tag ="<img style='width:20px;height:20px;margin:0px 2px;' src="+url+">" //<img src={url} style={{width:'20px',height:'20px',margin:'0px 2px'}}></img>
            }else{
                //为查询到表情
                tag = <span>{key}</span>
            }

            return (
                <span>{text.substr(0,matchResult.index)}
                <span dangerouslySetInnerHTML={{__html:tag}}></span>{this.showComment(text.substr(matchResult.index + key.length),map)}
                </span>
            )       ;
        }
    }


    //展示表情
    /*showComment(text,map){
        var reg = /(\[[^\]]+\])/;
        while(reg.test(text)){
            text = text.replace(reg,function(s,value){
                var url = map[value]?map[value]:''
                if(!url){
                    return "";
                }

                return "<img style='width:20px;height:20px;margin:0px 2px;' src="+url+">";
            })
        }
        return text;
    }*/

    //点赞加载更多
    likedMore(){
        this.state.pageNoLiked++;
        this.getLiked();
    }
    //分享加载更多
    shareMore(){
        this.state.pageNoShare++;
        this. getShare();
    }

    //点击加载更多评论
    markMore() {
        this.state.pageNo++;
        this.getMarked()
    }

    //微博评论
    createWeiboComment() {
        let body = {
            mediaCode: this.state.mediaCode,
            weiboId: this.state.weibo_mid,
            text: this.state.myInput,
        };
        if(this.state.myInput){
            if(!this.state.myInput.trim().length>0){
                message.warn('请输入评论内容');
                return;
            }
        }else{
            message.warn('请输入评论内容');
            return;
        }
        actions.createComment(body, (data) => {
            this.state.myInput = '';
            this.state.pageNo = 1;
            this.props.refresh&& this.props.refresh();
            this.getMarked()
        })
    }

    //回复评论
    replyComment(item){
        let body = {
            mediaCode: this.state.mediaCode,
            weiboId: this.state.weibo_mid,
            commentId: item.idstr,
            text:item.mark
        };
        if(item.mark){
            if(!item.mark.trim().length>0){
                message.warn('请输入评论内容');
                return;
            }
        }else{
            message.warn('请输入评论内容');
            return;
        }
        actions.replyComment(body, (data) => {
            this.state.myInput = '';
            this.state.pageNo = 1;
            this.props.refresh&& this.props.refresh();
            this.getMarked()
        })
    }

    //删除评论
    deleteMark(item) {

        confirm({
            title: '是否要删除本条评论 ？',
            onOk: ()=>
            {
                let body = {
                    mediaCode: this.state.mediaCode,
                    commentId: item.idstr
                };
                actions.delComment(body, (data) => {
                    this.state.pageNo = 1;
                    this.props.refresh&& this.props.refresh();
                    this.getMarked()
                })
            },
            onCancel() {},
        });
    }

    //微博，分享，点赞，评论的微博头像和名称点击打开微博
    openBlankWeiBo(idstr){

        window.open('https://www.weibo.com/u/'+idstr)
    }

    //表情包
    renderEmotionsDataSource(item) {
        if (this.state.emotionsDataSource.length === 0) {
            return <Empty/>
        }
        return (<div style={{width: "440px"}}>
            <Tabs type="line" size="small" tabBarGutter={0}>
                {
                    this.getEmotionType(item).map(etype => {
                        return etype;
                    })
                }
            </Tabs>
        </div>);
    }

    /*initEmotionsDataSource() {
        getAllEmotionsList(this.state.mediaCode, this.state.type, (data) => {
            if (data && data.length && data.length > 0) {
                this.setState({
                    emotionsDataSource: data,
                });
            }
        });
    }*/

    getEmotionType(item) {
        let sortBy = function (filed, rev, primer) {
            rev = (rev) ? -1 : 1;
            return function (a, b) {
                a = a[filed];
                b = b[filed];
                if (typeof (primer) != 'undefined') {
                    a = primer(a);
                    b = primer(b);
                }
                if (a < b) {
                    return rev * -1;
                }
                if (a > b) {
                    return rev * 1;
                }
                return 1;
            }
        };

        let types = [];
        let emotionTypes = this.state.emotionsDataSource;
        emotionTypes.sort(sortBy('indexnum', false, parseInt));
        for (let i = 0; i < emotionTypes.length; i++) {
            let emotionType = emotionTypes[i];
            types.push(<TabPane tab={emotionType.category} key={emotionType.indexnum}>
                <table>
                    <tbody>
                    {
                        this.setEmotions(emotionType.emotion,item).map(tr => {
                            return <tr key={uuid()}>
                                {tr.map(td => {
                                    return <td key={uuid()} width={36} height={34} align={"center"}
                                               style={{border: "1px solid #e8e8e8"}}>{td}</td>;
                                })}
                            </tr>
                        })
                    }
                    </tbody>
                </table>
            </TabPane>);
        }
        return types;
    }

    setEmotions(emotions,item) {
        let rowNum = 15; //一行显示15个
        let tdComponents = [];
        let saveIndex = 1;
        let tdComponent = [];
        for (let i = 0; emotions && i < emotions.length; i++) {
            let emotion = emotions[i];
            tdComponent.push(<img width={26} style={{padding: "2px", cursor: "pointer"}}
                                  onClick={this.insertEmotion.bind(this, emotion,item)} title={emotion.value}
                                  src={emotion.icon}/>);
            if (saveIndex == (rowNum)) {
                tdComponents.push(tdComponent);
                tdComponent = [];
                saveIndex = 0;
            } else {
                if (i == (emotions.length - 1)) {
                    tdComponents.push(tdComponent);
                }
            }
            saveIndex++;
        }
        return tdComponents;
    }

    insertEmotion(emotion,item) {
        if(item.idstr){
            //回复评论，里面添加表情
            item.mark=item.mark+emotion.value;
            this.setState({})
        }else{
            this.setState({myInput: this.state.myInput + emotion.value});
        }
        /* let newValue = this.contentWapper.insetIntoTextArea(emotion.value);
         this.setContent(newValue);*/
    }
}

class WeiboImage extends Component {
    constructor(props){
        super(props);
        this.state = {
            picUrls: this.props.picUrls
        }
    }

    showPics(pics)
    {
        let rows = [];
        rows.push(
            <table key={uuid()}>
                <tbody>
                {
                    this.setPics(pics).map(tr=>{
                        return <tr key={uuid()}>
                            {tr.map(td => {
                                return <td key={uuid()} width={36} height={34} align={"center"}>{td}</td>;
                            })}
                        </tr>
                    })
                }
                </tbody>
            </table>
        );
        return rows;
    }

    setPics(pics)
    {
        let rowNum = 3; //一行显示3个
        let tdComponents = [];
        let saveIndex = 1;
        let tdComponent = [];
        for(let i = 0; pics && i < pics.length; i++)
        {
            let pic = pics[i];
            tdComponent.push(<img style={{padding:"2px"}} width={120} height={120} src={pic}/>);
            if(saveIndex == (rowNum))
            {
                tdComponents.push(tdComponent);
                tdComponent = [];
                saveIndex = 0;
            }else {
                if(i == (pics.length-1))
                {
                    tdComponents.push(tdComponent);
                }
            }
            saveIndex++;
        }
        return tdComponents;
    }

    render() {
        return(
            <div style={{width:"360px"}}>
                {this.showPics(this.state.picUrls)}
            </div>
        )
    }
}